// src/api/finance/PublicInvoiceApi.ts
import { ENV } from "../../config/runtimeEnv";
import { ApiResponse } from "../../types/finance/FinanceTypes";
import { PublicInvoiceDto } from "../../types/finance/PublicInvoiceTypes";
import { http } from "../../lib/http/client";

// Same base URL as the rest of the finance API — the `/api` segment is already part of it.
const FINANCE_BASE_URL = ENV.VITE_FINANCE_SERVER || "/api/finance";

/**
 * Fetch the patient-facing invoice by its pay-link token — I6's `GET /api/public/invoice/:token`.
 *
 * ⚠️ **UNAUTHENTICATED BY DESIGN.** The public pay page renders for a patient who has no account
 * and no session; the per-invoice token IS the credential, and the gateway serves the route as
 * `capability` (contract §4.6). Do not read any cookie here.
 *
 * `PublicInvoiceApi.test.ts` asserts that no credential header is sent and that `js-cookie` is
 * never touched.
 *
 * The token travels as a PATH segment (the API contract). The emailed link carries it as
 * `?t=<token>` (I7); the page reads `?t=` from its own URL and passes the raw value here.
 */
export const fetchPublicInvoice = async (token: string): Promise<PublicInvoiceDto> => {
	const response = await http.get<ApiResponse<PublicInvoiceDto>>(
		`${FINANCE_BASE_URL}/public/invoice/${encodeURIComponent(token)}`,
	);
	return response.data.data;
};
